import { Component } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-things-to-do',
  standalone: false,
  templateUrl: './things-to-do.component.html',
  styleUrl: './things-to-do.component.css'
})
export class ThingsToDoComponent {
  constructor(private sidebarService: SidebarService) { }

  ngOnInit() {
    this.sidebarService.setTitle('Places to Visit');
  }

  ngOnDestroy() {
    this.sidebarService.clearTitle();
  }
}
